import { request } from '@/utils/request'

export interface AppConfigResponse {
    [key: string]: any;
}

/** 获取应用配置 */
export function getAppConfig(key: string): Promise<AppConfigResponse> {
    return request<AppConfigResponse>({
        url: '/api/confSvcExt/getConfByKey',
        method: 'get',
        params: { key }
    })
}
